// src/components/PrivacyPolicy.js
import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto", fontFamily: "Arial, sans-serif" }}>
      <h1>OkGather Privacy Policy</h1>
      <p><strong>Effective Date:</strong> January 1, 2025</p>
      <p><strong>Company Address:</strong> 128 City Road, London, United Kingdom, EC1V 2NX</p>
      <h2>1. Introduction</h2>
      <p>
        At OkGather, we are committed to protecting your privacy. This Privacy Policy explains how we
        collect, use, disclose, and safeguard your personal information when you use our services.
      </p>
      <h2>2. Information We Collect</h2>
      <p>
        We may collect personal information including, but not limited to, your name, email address,
        birth year, and other profile information that you provide when you sign up or use our services.
      </p>
      <h2>3. How We Use Your Information</h2>
      <p>
        We use your information to provide, maintain, and improve our services; to communicate with you;
        and to personalize your experience on our platform. We may also use your information to comply with legal obligations.
      </p>
      <h2>4. Sharing Your Information</h2>
      <p>
        We do not sell your personal information. However, we may share information with trusted third parties
        to help us operate our services, such as payment processors or email service providers, under strict confidentiality agreements.
      </p>
      <h2>5. Security</h2>
      <p>
        We take reasonable measures to protect your personal information from unauthorized access, use, or disclosure.
        However, no method of transmission over the Internet or method of electronic storage is 100% secure.
      </p>
      <h2>6. Your Rights</h2>
      <p>
        Depending on your location, you may have the right to access, correct, or delete your personal information.
        Please contact us at info@okgather.com to exercise these rights.
      </p>
      <h2>7. Changes to This Privacy Policy</h2>
      <p>
        We may update our Privacy Policy from time to time. Any changes will be posted on this page and will take effect immediately upon publication.
      </p>
      <h2>8. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at info@okgather.com.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
